import { TimerState } from "../models/model";
import { agentTimerActions } from "../interface/reducerType";

const initialState = {
  queueTrackerData: [],
  agentTrackerData: [],
  interval: "",
};
export const agentTimerReducer = (
  state: TimerState = initialState,
  action: agentTimerActions
) => {
  switch (action.type) {
    case "QUEUE_TRACKER_DATA":
      return { ...state, queueTrackerData: action.payload.queueTrackerData };
    case "AGENT_TRACKER_DATA":
      return {
        ...state,
        agentTrackerData: action.payload.agentTrackerData
      };
    default:
      return state;
  }
};
